import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  public isenabled: any[] = [
    {
      value:true,
      name:"MetaData.Enabled"
    },
    {
      value:false,
      name:"MetaData.Disabled"
    }
  ];

  public YesNo: any[] = [
    {
      value:true,
      name:"MetaData.Yes"
    },
    {
      value:false,
      name:"MetaData.No"
    }
  ];

  constructor() { }

}
